import Model from '@/models/Model'

export default class SlCustomer extends Model {
    static includes = []
    static appends = ['branch_offices', 'discount']

    resource() {
        return 'sl_customer'
    }

    get addressCustomer() {
        try {
            let { branch_offices } = this
            if (branch_offices.length > 0)
                return branch_offices
                    .slice()
                    .map(branch_office => branch_office.address)
                    .join('\n')
            else return '-'
        } catch (e) {
            return ''
        }
    }
}
